import { render, staticRenderFns } from "./SW.vue?vue&type=template&id=74184f3d&scoped=true"
import script from "./SW.vue?vue&type=script&lang=js"
export * from "./SW.vue?vue&type=script&lang=js"
import style0 from "./SW.vue?vue&type=style&index=0&id=74184f3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74184f3d",
  null
  
)

export default component.exports